import Swal from 'sweetalert2'
import MapComponent from '../components/MapComponent';

export default function Contact() {
    const handleSubmit = async (e) => {
        e.preventDefault();

        const name = document.getElementById("form-name").value;
        const email = document.getElementById("form-email").value;
        const message = document.getElementById("form-message").value;

        fetch('https://musashijj.cl/login/script/sendEmail.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name,
                email,
                message
            })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(result => {
                Swal.fire({
                    title: "Correo Enviado!",
                    text: "El correo electrónico ha sido enviado exitosamente!",
                    icon: "success"
                });
                document.getElementById("form-name").value = "";
                document.getElementById("form-email").value = "";
                document.getElementById("form-message").value = "";
                console.log(result);
            })
            .catch(error => {
                Swal.fire({
                    title: "Error!",
                    text: "El correo electrónico no ha sido enviado",
                    icon: "error"
                });
                document.getElementById("form-name").value = "";
                document.getElementById("form-email").value = "";
                document.getElementById("form-message").value = "";
                console.log(error);
            });
    };

    return (
        <>
            <h2 className="h2-title">Información de Contacto</h2>
            <div className="contacto-contenido">
                <article>
                    <div>
                        <p className="title">Correo electrónico</p>
                        <p className="data">
                            <a className="contacto-link" href="mailto:musashi.jjchile@gmail.com">musashi.jjchile@gmail.com</a>
                        </p>
                    </div>
                    <div>
                        <p className="title">Teléfono</p>
                        <p className="data">
                            <a className="contacto-link" href="tel:+56948999358">+56 9 4899 9358</a>
                        </p>
                    </div>
                    <div>
                        <p className="title">Ubicación</p>
                        <p className="data">Av. Hernando de Aguirre 162, oficina 204, Providencia</p>
                    </div>
                </article>
                <form onSubmit={(e) => handleSubmit(e)}>
                    <div>
                        <label htmlFor="form-name" className="form-label title">Nombre *</label>
                        <input type="text" className="form-control" id="form-name" placeholder="Nombre" required />
                    </div>
                    <div>
                        <label htmlFor="form-email" className="form-label title">Correo electrónico *</label>
                        <input type="email" className="form-control" id="form-email" placeholder="nombre@ejemplo.com" autoComplete="off" required />
                    </div>
                    <div>
                        <label htmlFor="form-message" className="form-label title">Mensaje *</label>
                        <textarea className="form-control" id="form-message" rows="3" placeholder="Escribe tu mensaje..." required></textarea>
                    </div>
                    <input aria-label="Enviar mensaje" id="form-button" className="btn btn-primary form-button" type="submit" value="Enviar mensaje"></input>
                </form>
            </div>
            <MapComponent />
        </>
    );
};
